import { render, staticRenderFns } from "./AppPlayer.vue?vue&type=template&id=54f62ab6&scoped=true"
import script from "./AppPlayer.vue?vue&type=script&lang=js"
export * from "./AppPlayer.vue?vue&type=script&lang=js"
import style0 from "./AppPlayer.vue?vue&type=style&index=0&id=54f62ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f62ab6",
  null
  
)

export default component.exports